interface AvatarProps {
  name?: string;
  email: string;
  avatarUrl?: string | null;
  // Extra classes for sizing/spacing. Defaults to the 32px header size.
  className?: string;
}

// Avatar renders a member's Google photo, falling back to initials on a soft
// accent chip. Shared by the header account cluster, the account menu, and the
// team roster rows.
export function Avatar({ name, email, avatarUrl, className }: AvatarProps) {
  const initials = name?.trim()
    ? name
        .trim()
        .split(/\s+/)
        .map((p) => p[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    : email.slice(0, 2).toUpperCase();

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-accent/20 text-accent text-xs font-semibold overflow-hidden shrink-0 ${
        className ?? 'w-8 h-8'
      }`}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt="" className="w-full h-full rounded-full object-cover" />
      ) : (
        <span>{initials}</span>
      )}
    </span>
  );
}
